import React, { useEffect, useState } from "react";
import Layout from "../../elements/Layout";
import { getSalesTrendsReports } from "../../utils/api/api";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";

const SalesTrendsReports = () => {
    const [report, setReport] = useState(null);

    useEffect(() => {
        const getReport = async () => {
            try {
                const response = await getSalesTrendsReports();
                setReport(response);
            } catch (error) {
                console.error("Error fetching sales trends:", error);
            }
        };

        getReport();
    }, []);

    if (!report) return <p>Loading...</p>;

    const dailyData = report.daily_sales_trend.map((item) => ({
        date: item.day,
        sales: parseFloat(item.sales_trend),
    }));

    const weeklyData = report.weekly_sales_trend.map((item) => ({
        date: `Week ${item.week} - ${item.year}`,
        sales: parseFloat(item.sales_trend),
    }));

    const monthlyData = report.monthly_sales_trend.map((item) => ({
        date: item.month,
        sales: parseFloat(item.sales_trend),
    }));

    const yearlyData = report.yearly_sales_trend.map((item) => ({
        date: item.year,
        sales: parseFloat(item.sales_trend),
    }));

    return (
        <Layout text="Sales Trends Reports">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4">
                {/* Daily Sales Trend */}
                <div className="p-4 border rounded-lg shadow">
                    <h2 className="text-lg font-semibold mb-2">Daily Sales Trend</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <LineChart data={dailyData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="sales" stroke="#8884d8" />
                        </LineChart>
                    </ResponsiveContainer>
                </div>

                {/* Weekly Sales Trend */}
                <div className="p-4 border rounded-lg shadow">
                    <h2 className="text-lg font-semibold mb-2">Weekly Sales Trend</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <LineChart data={weeklyData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="sales" stroke="#82ca9d" />
                        </LineChart>
                    </ResponsiveContainer>
                </div>

                {/* Monthly Sales Trend */}
                <div className="p-4 border rounded-lg shadow">
                    <h2 className="text-lg font-semibold mb-2">Monthly Sales Trend</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <LineChart data={monthlyData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="sales" stroke="#ffc658" />
                        </LineChart>
                    </ResponsiveContainer>
                </div>

                {/* Yearly Sales Trend */}
                <div className="p-4 border rounded-lg shadow">
                    <h2 className="text-lg font-semibold mb-2">Yearly Sales Trend</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <LineChart data={yearlyData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="sales" stroke="#d45087" />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </Layout>
    );
};

export default SalesTrendsReports;
